<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">配餐计划添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="早餐配餐"  required prop="morningPlan">
                                    <el-select
                                        v-model="addForm.morningPlan"
                                        multiple
                                        style="width:100%"
                                        filterable
                                        placeholder="请选择菜品">
                                        <el-option
                                            v-for="item in dishesList"
                                            :key="item.dishesCode"
                                            :label="item.name"
                                            :value="item.dishesCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            
                            <el-col :span="12" class="item">
                                <el-form-item label="午餐配餐" required prop="noonPlan">
                                    <el-select
                                        v-model="addForm.noonPlan"
                                        multiple
                                        filterable
                                        style="width:100%"
                                        placeholder="请选择菜品">
                                        <el-option
                                            v-for="item in dishesList"
                                            :key="item.dishesCode"
                                            :label="item.name"
                                            :value="item.dishesCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="晚餐配餐" required prop="nightPlan">
                                    <el-select
                                        v-model="addForm.nightPlan"
                                        multiple
                                        filterable
                                        style="width:100%"
                                        placeholder="请选择菜品">
                                        <el-option
                                            v-for="item in dishesList"
                                            :key="item.dishesCode"
                                            :label="item.name"
                                            :value="item.dishesCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="12" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>早餐配餐</span>
                                        <el-button class="dishesPlanAdd" type="primary" @click="dishesPlanMorningAdd">添加</el-button>
                                    </div>
                                    <el-col :span="24">
                                        <div style="padding: 0px 0 20px;text-align:center">
                                            <span>蔬菜</span>
                                        </div>
                                    </el-col>
                                </el-card>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>中餐配餐</span>
                                        <el-button class="dishesPlanAdd" type="primary">添加</el-button>
                                    </div>
                                    <el-col :span="24">
                                        <div style="padding: 0px 0 20px;text-align:center">
                                            <span>蔬菜</span>
                                        </div>
                                    </el-col>
                                </el-card>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>晚餐配餐</span>
                                        <el-button class="dishesPlanAdd" type="primary">添加</el-button>
                                    </div>
                                    <el-col :span="24">
                                        <div style="padding: 0px 0 20px;text-align: center;">
                                            <span>蔬菜</span>
                                        </div>
                                    </el-col>
                                </el-card>
                            </el-col> -->
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['dishesList'],
        data() {
            return {
                loading: false,
                floor:null,
                morningPlan:[],
                noonPlan:[],
                nightPlan:[],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    timeArr:[],
                    morningPlan:[],
                    noonPlan:[],
                    nightPlan:[],
                    dishesPlan:{
                        morningPlan:[],
                        noonPlan:[],
                        nightPlan:[],
                    }
                },
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    },
                },
                rules:{
                    time:[
                        { required: true, message: '请选择时间', trigger: 'blur' },
                    ],
                    morningPlan:[
                        { required: true, message: '请选择早餐菜品', trigger: 'blur' },
                    ],
                    noonPlan:[
                        { required: true, message: '请选择午餐菜品', trigger: 'blur' },
                    ],
                    nightPlan:[
                        { required: true, message: '请选择晚餐菜品', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(dateList){
                this.$refs.addForm.resetFields();
                this.addForm.timeArr=dateList
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        if(this.addForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.dishesPlan.morningPlan=this.addForm.morningPlan
                this.addForm.dishesPlan.noonPlan=this.addForm.noonPlan
                this.addForm.dishesPlan.nightPlan=this.addForm.nightPlan
               
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"DishesPlan/AddMany",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                            this.addForm.morningPlan=null
                            this.addForm.noonPlan=null
                            this.addForm.nightPlan=null
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width:700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .box-card{
                margin: 10px 0;
            }
            .dishesPlanAdd{
                float: right;transform: translate(0px, -9px);
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
